import { MenuItemProcessingRule } from '../interfaces';

const PRICING_COLUMNS = [
	'precio',
	'precioBase',
	'productosCanal.precios.preciosEspeciales.diasAsociados.valor',
	'productosCanal.precios.preciosEspeciales.rangoFechaAsociado.valor',
	'productosCanal',
	'precios',
	'preciosEspeciales',
	'diasAsociados',
	'rangoFechaAsociado',
	'gruposModificadores',
	'grupoModificador',
	'detallesmodificadores',
];

const TAX_COLUMNS = ['impuestos', 'impuestos.valor'];

export const menuItemPricesToBigIntRule: MenuItemProcessingRule = context => {
	const pricingValues = context.precisionService.changePrecisionsObjectToInternal(
		context.items,
		PRICING_COLUMNS
	);
	const items = context.precisionService.changePrecisionsObjectToInternal(
		pricingValues,
		TAX_COLUMNS
	);

	return { ...context, items };
};
